import { useEffect, useRef, useState } from "react";

export const useDebounce = <T = any>(value: T, delay = 500) => {
  const defaultValue = typeof value === 'string' ? '' : {};
  const [debouncedValue, setDebouncedValue] = useState<T>(defaultValue as T);
  const timerRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => setDebouncedValue(value), delay);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [value, delay]);

  return [debouncedValue];
};